// extracted by mini-css-extract-plugin
export var alertIcon = "_pv-0";